import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LibraryComponentService } from '@service/library-component.service';
import { LibraryService } from '@service/library.service';
import { Library, LibraryAndCategories } from 'icreate/common/models/library';
import { LibraryCategory } from 'icreate/common/models/library-category';
import { LibraryComponent } from 'icreate/common/models/library-component';

@Component({
    selector: 'app-select-library-component-dialog',
    templateUrl: './select-library-component-dialog.component.html',
    styleUrls: ['./select-library-component-dialog.component.css'],
    standalone: false,
})
export class SelectLibraryComponentDialogComponent {
    selectedLibrary: LibraryAndCategories;
    selectedCategory: LibraryCategory;
    selectedComponent: LibraryComponent;

    selectedLibraryCategoryList: LibraryCategory[] = [];
    selectedComponentList: LibraryComponent[] = [];

    isLoading: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            libraryList: LibraryAndCategories[];
            selectedComponent: LibraryComponent;
        },
        private dialogRef: MatDialogRef<SelectLibraryComponentDialogComponent>,
        private libraryComponentSerivce: LibraryComponentService
    ) {}

    async ngOnInit() {
        if (this.data.selectedComponent) {
            let selectedCategory;
            const findIndex = this.data.libraryList.findIndex(library => {
                const findIndex = library.libraryCategories.findIndex(
                    category => this.data.selectedComponent.libraryCategoryId === category.id
                );
                if (findIndex !== -1) {
                    selectedCategory = library.libraryCategories[findIndex];
                    return true;
                }
                return false;
            });

            this.selectedLibrary = this.data.libraryList[findIndex];
            this.selectedLibraryCategoryList = this.data.libraryList[findIndex].libraryCategories;
            this.selectedCategory = selectedCategory;
            this.selectedComponentList = await this.libraryComponentSerivce.getByLibraryCategoryId(
                this.selectedCategory.id
            );
            this.selectedComponent = this.data.selectedComponent;
        }
    }

    selectLibrary(library: Library) {
        this.selectedLibrary = library;
        this.selectedLibraryCategoryList = this.selectedLibrary.libraryCategories;
        this.selectedCategory = undefined;
        this.selectedComponent = undefined;
    }

    selectComponent(component: LibraryComponent) {
        this.selectedComponent = component;
    }

    async selectCategory(category: LibraryCategory) {
        try {
            this.isLoading = true;

            this.selectedCategory = category;
            this.selectedComponentList = await this.libraryComponentSerivce.getByLibraryCategoryId(
                this.selectedCategory.id
            );
            this.selectedComponent = undefined;
        } catch (error) {
            console.log(error);
        } finally {
            this.isLoading = false;
        }
    }

    close() {
        this.dialogRef.close(false);
    }

    isSelectButtonDisabled() {
        return !this.selectedComponent;
    }

    select() {
        this.dialogRef.close(this.selectedComponent);
    }
}
